module.exports = __webpack_public_path__ + "assets/b89.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b89.png
// module id = 681
// module chunks = 0